//Default Paginations
export const DEFAULT_PAGINATIONS = [
  {
    text: "If the pagination component is used to navigate between a set of search results, an appropriate label could be ",
    code: 'aria-label="Search results pages"',
  },
];

//Pagination With Active And Disabled
export const ACTIVE_DISABLE_PAGINATIONS = [
  {
    text: "Use ",
    code: ".disabled ",
  },
  {
    text: "for links that appear un-clickable and",
    code: " .active",
  },
  {
    text: " to indicate the current page.",
  },
];

//Pagination With Icons
export const ICON_PAGINATIONS = [
  {
    text: "Use an icon or symbol in place of text for some pagination links.",
  },
];

//Rounded Paginations
export const ROUNDED_PAGINATIONS = [
  {
    text: "Used in rounded pagination.Use an icon or symbol in place of text for some pagination links.",
    code: "[.rounded-circle]",
  },
];

//Pagination Alignments

export const ALIGNMENT_PAGINATIONS = [
  {
    text: "Change the alignment of pagination components with flexbox utilities. For example, with ",
    code: ".justify-content-center:.",
  },
];

export const ALIAGNMENT_DATA = [
  {
    className: "justify-content-center m-b-30",
    active: true,
    color: "danger",
    smallText:true
  },
  {
    className: "justify-content-end",
    color: "success",
  },
];

//Pagination Sizings
export const SIZING_PAGINATIONS = [
  {
    text: "Use ",
    code: "[pagination-lg/pagination-md/pagination-lg]",
  },
  {
    text: " for additional sizes.",
  },
];

export const SIZING_DATA = [
  {
    className: "m-b-30",
    size: "md",
  },
  {
    size: "sm",
  },
];
